export const GRAPHQL_VARIABLES = {
  record: {
    companyId: '5fbdb1a50c228f35dd575a37',
    status: 'draft',
    amountDue: 10000
  },
  filter: {
    _id: '5fc44a6984ffd06759c1a1e1'
  }
};

export const QUERY = `
  mutation invoicesUpdateOne ($record: UpdateOneinvoicesInput!, $filter: AutoFilledFilterUpdateOneinvoicesInput!, $sort: SortUpdateOneinvoicesInput, $skip: Int) {
    invoicesUpdateOne (record: $record, filter: $filter, sort: $sort, skip: $skip) {
        recordId
        record {
            companyId
            customerId
            status
            allowedPaymentTypes
            currency
            total
            paid
            amountDue
            amountPaid
            metadata
            bkInvoice
            _id
            updatedAt
            createdAt
        }
        error {
            message
        }
    }
  }
`;
